<script>
import appBankList from '@shared/components/shared/bankList.vue'
import { useHead } from '@unhead/vue'
import { designSystem } from 'tb-design_system-web'
import { ref } from 'vue'

export default {
  name: 'DesignSystemDemo',

  components: {
    designSystem,
    appBankList
  },

  setup() {
    useHead({ title: 'DesignSystem' })

    const statusValue = ref(0)
    const uploadedFileUrls = ref([])
    const loading = ref(false)

    const status = ref([
      { key: '0', name: 'Selecione uma opção' },
      { key: '1', name: 'Primeira opção' },
      { key: '2', name: 'Segunda opção' },
      { key: '3', name: 'Terceira opção' },
      { key: '4', name: 'Quarta opção' }
    ])
    const radio = ref([
      { key: 'radio1', name: 'Radio 1' },
      { key: 'radio2', name: 'Radio 2' },
      { key: 'radio3', name: 'Radio 3' },
      { key: 'radio4', name: 'Radio 4' },
      { key: 'radio5', name: 'Radio 5' }
    ])
    const checkbox = ref([
      { key: 'checkbox1', name: 'Checkbox 1' },
      { key: 'checkbox2', name: 'Checkbox 2' },
      { key: 'checkbox3', name: 'Checkbox 3' },
      { key: 'checkbox4', name: 'Checkbox 4' },
      { key: 'checkbox5', name: 'Checkbox 5' }
    ])
    const switchOp = ref([
      { key: 'switch1', name: 'Switch 1' },
      { key: 'switch2', name: 'Switch 2' },
      { key: 'switch3', name: 'Switch 3' },
      { key: 'switch4', name: 'Switch 4' },
      { key: 'switch5', name: 'Switch 5' }
    ])
    const fileTypes = ref([
      { key: '0', name: 'Selecione uma opção' },
      { key: '1', name: 'Primeira opção' },
      { key: '2', name: 'Segunda opção' },
      { key: '3', name: 'Terceira opção' },
      { key: '4', name: 'Quarta opção' }
    ])

    const bankOptions = ref([
      {
        key: '0',
        name: 'Banco 1',
        country: 'Brasil',
        bank: '001',
        account: '123456',
        swift: 'ABC123'
      },
      { key: '1', name: 'Banco 2', country: 'EUA', bank: '002', account: '654321', swift: 'XYZ789' }
    ])

    const configMoney = {
      debug: false,
      masked: false,
      prefix: 'R$',
      suffix: '',
      thousands: ',',
      decimal: '.',
      precision: 2,
      disableNegative: false,
      disabled: false,
      min: null,
      max: null,
      allowBlank: false,
      minimumNumberOfCharacters: 0,
      modelModifiers: {
        number: false
      },
      shouldRound: true,
      focusOnRight: false
    }

    const toggleDarkMode = () => {
      const htmlElement = document.documentElement
      htmlElement.classList.toggle('dark')
    }

    const handleFileSelected = async (files) => {
      for (const file of files) {
        loading.value = true
        const fileUrl = await uploadFileToS3(file)
        uploadedFileUrls.value.push(fileUrl)
        loading.value = false
      }
    }

    // TODO: Exemplo para chamada de API
    const uploadFileToS3 = async (file) => {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      return `https://example.com/${file.name}`
    }

    const removeFile = (index) => {
      if (index >= 0 && index < uploadedFileUrls.value.length) {
        uploadedFileUrls.value.splice(index, 1)
      }
    }

    return {
      statusValue,
      status,
      radio,
      checkbox,
      switchOp,
      toggleDarkMode,
      handleFileSelected,
      uploadFileToS3,
      bankOptions,
      uploadedFileUrls,
      fileTypes,
      removeFile,
      configMoney,
      loading
    }
  }
}
</script>

<template>
  <div>
    <design-system />

    <section class="container pt-5 pb-5">
      <div class="row">
        <div class="col-12 col-md-6"></div>
        <div class="col-12 col-md-6">
          <div class="row">
            <app-title label="DADOS BANCÁRIOS DO BENEFICIÁRIO" />

            <app-bank-list :initialBanks="bankOptions" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
